"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Popper_1 = __importDefault(require("@mui/material/Popper"));
const ClickAwayListener_1 = __importDefault(require("@mui/material/ClickAwayListener"));
const Autocomplete_1 = __importStar(require("@mui/material/Autocomplete"));
const Input_1 = __importDefault(require("@mui/material/Input"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const lodash_1 = __importDefault(require("lodash"));
const q_play_core_1 = require("@nordicscreen/q-play-core");
const onlineResourceManager = new q_play_core_1.OnlineResourceManager();
const LabelField = (props) => {
    const { width, clickHandler, value, placeholder } = props, rest = __rest(props, ["width", "clickHandler", "value", "placeholder"]);
    return (react_1.default.createElement(Box_1.default, Object.assign({ style: { width: width }, sx: {
            fontSize: "14px",
            border: "var(--ns-border)",
            borderRadius: "4px",
            height: "2rem",
            color: "var(--info-color)",
            padding: "0 10px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        }, onClick: clickHandler }, rest),
        react_1.default.createElement("span", null, value ? value : placeholder)));
};
const searchField = (params) => {
    return (react_1.default.createElement(Input_1.default, { sx: {
            border: "var(--ns-border)",
            width: "100%",
            padding: "0 10px",
            backgroundColor: "#ffffff"
        }, ref: params.InputProps.ref, inputProps: params.inputProps, autoFocus: true, placeholder: "Search" }));
};
const itemField = (props, option) => {
    return (react_1.default.createElement("li", Object.assign({ key: option.label }, props),
        react_1.default.createElement(Box_1.default, null, option.label)));
};
const AdvancedSelect = (props) => {
    const { option_object, placeholder = "PLACEHOLDER", no_option_text = "No options", valueSelectCallback, selected_value, disabled = false, readOnly = false, dataKey = "" } = props, rest = __rest(props, ["option_object", "placeholder", "no_option_text", "valueSelectCallback", "selected_value", "disabled", "readOnly", "dataKey"]);
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const [value, setValue] = (0, react_1.useState)(null);
    const [pendingValue, setPendingValue] = (0, react_1.useState)(null);
    const [options, setOptions] = (0, react_1.useState)([]);
    // Only relevant if data comes from an endpoint.
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [shouldUseFilter, setShouldUseFilter] = (0, react_1.useState)(true);
    const [shouldThrottle, setShouldThrottle] = (0, react_1.useState)(false);
    const getOptionsFromEndpoint = (0, react_1.useCallback)((url, response_data_path, label_property, value_property) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield onlineResourceManager.makeJSONRequest(url, "GET").getResponseRaw();
        const data = lodash_1.default.get(response.data, response_data_path);
        if (!data && typeof data !== "object")
            return;
        const parsedOptions = [];
        const dataArr = Array.from(data);
        dataArr.forEach((option) => {
            if (!option && typeof option !== "object")
                return;
            const label = lodash_1.default.get(option, label_property);
            const value = lodash_1.default.get(option, value_property);
            if (!label && !value)
                return;
            parsedOptions.push({ value: value, label: label });
        });
        setOptions(parsedOptions);
    }), [onlineResourceManager]);
    const debouncedGetOptionsFromEndpoint = new q_play_core_1.Debouncer(getOptionsFromEndpoint, 1000);
    (0, react_1.useEffect)(() => {
        if (selected_value) {
            setValue(selected_value);
            setOptions([selected_value]);
        }
        const usesEndpoint = "url" in option_object && "response_data" in option_object;
        const usesStatic = "options" in option_object;
        if (usesEndpoint) {
            const { should_fetch_on_load = true, should_throttle_request = false, should_use_local_filter = true, url = "", search_param = "", response_data = "", } = option_object;
            setShouldUseFilter(should_use_local_filter);
            setShouldThrottle(should_throttle_request);
            const endpoint = url;
            if (should_fetch_on_load) {
                setLoading(true);
                const url = endpoint.replace(new RegExp(search_param, "gi"), "");
                getOptionsFromEndpoint(url, response_data, option_object.label_property, option_object.value_property).then(() => {
                    setLoading(false);
                });
            }
        }
        else if (usesStatic && option_object.options) {
            const parsedOptions = [];
            option_object.options.forEach((option) => {
                if (!option && typeof option !== "object")
                    return;
                const label = lodash_1.default.get(option, option_object.label_property);
                const value = lodash_1.default.get(option, option_object.value_property);
                if (!label && !value)
                    return;
                parsedOptions.push({ value: value, label: label });
            });
            setOptions(parsedOptions);
        }
    }, []);
    const searchHandler = (event, value, reason) => {
        if (reason !== "input" || !shouldThrottle)
            return;
        const { url = "", search_param = "", response_data = "", label_property, value_property, } = option_object;
        const endpoint = url.replace(new RegExp(search_param, "gi"), value);
        debouncedGetOptionsFromEndpoint.debounce(endpoint, response_data, label_property, value_property);
    };
    const handleClick = (event) => {
        setPendingValue(value);
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setValue(pendingValue);
        if (anchorEl) {
            anchorEl.focus();
        }
        setAnchorEl(null);
        valueSelectCallback(pendingValue, dataKey);
    };
    const open = Boolean(anchorEl);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(LabelField, Object.assign({ clickHandler: handleClick, placeholder: placeholder, value: value === null || value === void 0 ? void 0 : value.label }, rest)),
        react_1.default.createElement(Popper_1.default, { open: open, anchorEl: anchorEl, placement: "bottom-start", style: {
                width: open ? anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.getBoundingClientRect().width : "0px",
            } },
            react_1.default.createElement(ClickAwayListener_1.default, { onClickAway: handleClose },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Autocomplete_1.default, { disabled: disabled, readOnly: readOnly, open: true, onClose: (event, reason) => {
                            if (reason === "escape") {
                                handleClose();
                            }
                        }, value: pendingValue, onChange: (event, newValue, reason) => {
                            if (event.type === "keydown" &&
                                (event.key === "Backspace" ||
                                    event.key === "Delete") &&
                                reason === "removeOption") {
                                return;
                            }
                            setPendingValue(newValue);
                        }, disableCloseOnSelect: true, noOptionsText: no_option_text, renderInput: searchField, onInputChange: searchHandler, renderOption: itemField, options: options, filterOptions: (options, state) => {
                            if (shouldUseFilter) {
                                return (0, Autocomplete_1.createFilterOptions)()(options, state);
                            }
                            else {
                                return options;
                            }
                        }, getOptionLabel: (option) => option.label, loading: loading }))))));
};
exports.default = AdvancedSelect;
